<template>
	<ul>
		<li class="order-detail p-b">
			<div class="link-wrap">
				<img src="../assets/images/home/ic_home_line_2.png" alt="" class="pt-img"/>
				<span class="link">业务信息</span>
			</div>
			
			<div class="customer-info">
				<span class="info-style">处理人员</span>
				<span class="info-style">{{detailList.salesman_name}}</span>
			</div>

			<div class="customer-info">
				<span class="info-style">订单佣金</span>
				<span class="info-style info-co">¥{{detailList.commission_price}}</span>
			</div>        
		</li>
	</ul>
</template>

<script>
    export default {
		props:{
			detailList:{
				type: Object,
			},
		},
        name: 'submitPay',
        methods: {
			submit(){
				this.$emit("submitClick")
			}
        },
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
	.order-detail{margin-bottom: 10px;background: #fff}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;font-weight: 600;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
	.info-style{color:rgba(74,74,74,1);font-size: 14px}
	.p-b{padding-bottom:8px}
	.info-co{font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,134,48,1);}
</style>
